import { Text, HStack, Box, Circle } from '@chakra-ui/react';
import React from 'react';

import { ShoppingCartIcon } from '@/imports/ui/chakra/feather';
import { useCart } from '@/state/cart/useCart';

export const OrderSummaryHeader: React.FC = () => {
  const { itemCount = 0 } = useCart();

  return (
    <HStack spacing="2">
         <Text fontSize="lg" fontWeight="semibold">
        Order Summary
      </Text>
      <Box position="relative">
        <ShoppingCartIcon boxSize="5" />
        {itemCount > 0 && (
          <Circle
            position="absolute"
            top={-2}
            right={-2}
            size={5}
            backgroundColor="red.600"
            zIndex={2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <Text 
              color="white" 
              fontSize={12} 
              lineHeight="1em"
              fontWeight="bold"
            >
              {itemCount > 9 ? '9+' : itemCount}
            </Text>
          </Circle>
        )}
      </Box>
     
    </HStack>
  );
};